import React from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "./components/Loader";
const Projects = React.lazy(() => import("./views/Projects"));
const ProjectMenu = React.lazy(() => import("./views/ProjectMenu"));
const Home = React.lazy(() => import("./views/Home"));
const OurWorkPage = React.lazy(() => import("./views/OurWorkPage"));
const OurWork2 = React.lazy(() => import("./views/OurWork2"));
const OurUSP = React.lazy(() => import("./views/OurUSP"));
const WhoWeAre = React.lazy(() => import("./views/WhoWeAre"));
const OurTeam = React.lazy(() => import("./views/OurTeam"));
const OurTeamModal = React.lazy(() => import("./views/OurTeam"));
const ContactUs = React.lazy(() => import("./views/ContactUs"));
const Gallery = React.lazy(() => import("./views/Gallery"));
const Videos = React.lazy(() => import("./views/Videos"));
const VideosModal = React.lazy(() => import("./views/Videos"));
const Publications = React.lazy(() => import("./views/Publications"));
const Webinars = React.lazy(() => import("./views/Webinars"));
const WebinarParticular = React.lazy(() => import("./views/WebinarParticular"));
const Blogs = React.lazy(() => import("./views/Blogs"));
const BlogDetail = React.lazy(() => import("./views/Blogs/BlogDetail"));
const EventPage = React.lazy(() => import("./views/EventPage"));
const Component2page = React.lazy(() => import("./views/Component2page"));
const Component3page = React.lazy(() => import("./views/Component3page"));
const Home2 = React.lazy(() => import("./views/Home2"));
const Newcomponent1 = React.lazy(() => import("./views/Newcomponent1"));
const Citiis22 = React.lazy(() => import("./views/Citiis22"))

export const routes = [
  { path: "/", element: Home },
  {
    path: "/citiis2",
    element: Home2,
    name: "About",
  },
  {
    path: "/citiis22",
    element: Citiis22,
    name: "About",
  },
  {
    path: "/ourwork",
    element: OurWorkPage,
    name: "Our Work",
  },
  {
    path: "/ourwork2",
    element: OurWork2,
    name: "Our Work 2.0",
  },
  {
    path: "/ourusp",
    element: OurUSP,
    name: "Our USPs",
  },
  {
    path: "/whoweare",
    element: WhoWeAre,
    name: "Who We Are",
  },
  {
    path: "/ourteam",
    element: OurTeam,
    name: "Our Team",
  },
  {
    path: "/ourteam/*",
    element: OurTeamModal,
    name: "Our Team",
  },
  {
    path: "/contactus",
    element: ContactUs,
    name: "Contact Us",
  },
  {
    path: "/projects/*",
    element: Projects,
  },
  {
    path: "/project-menu/*",
    element: ProjectMenu,
  },
  {
    path: "/gallery",
    element: Gallery,
    name: "Gallery",
  },
  {
    path: "/videos",
    element: Videos,
    name: "Videos",
  },
  {
    path: "/videos/*",
    element: VideosModal,
    name: "Videos",
  },
 {
  path: "/publications",
  element: Publications,
  name: "Publications",
},
{
  path: "/publications/:category",
  element: Publications,
  name: "Publications",
},
  {
    path: "/webinars",
    element: Webinars,
    name: "Webinars",
  },
  {
    path: "/webinar/*",
    element: WebinarParticular,
    name: "Webinars",
  },
  {
    path: "/blogs",
    element: Blogs,
    name: "Blogs",
  },
  {
    path: "/blogs/*",
    element: BlogDetail,
    name: "Blogs",
  },
  {
    path: "/event/*",
    element: EventPage,
    name: "EventPage",
  },
  {
    path: "/newcomponent1",
    element: Newcomponent1,
    name: "Component 1",
  },
  {
    path: "/component2",
    element: Component2page,
    name: "Component2",
  },
  {
    path: "/component3",
    element: Component3page,
    name: "Component3",
  },
];

export const AppRoutes = () => {
  return (
    <Routes>
      {routes.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            element={
              <React.Suspense fallback={<Loader />}>
                <route.element />
              </React.Suspense>
            }
          />
        );
      })}
    </Routes>
  );
};
